import React from 'react';
import useSheet from 'app/jss';
import colorUtils from 'color';
import classNames from 'classnames';
import GroupContainerHeader from 'app/components/friends/GroupContainerHeader';


type Props = {
  classes: Object,
  children?: any,
  className?: string,
  invert?: boolean,
};

type State = {
  isSearching: boolean,
  activeCategory: string,
  searchTerm: string,
};

class GroupContainer extends React.Component {
  props: Props;
  state: State = {
    searchTerm: '',
    isSearching: false,
  };

  static defaultProps = {
    children: undefined,
    className: undefined,
    invert: false,
    noSearch: false,
  };

  render() {
    const {
      classes,
      children,
      className,
      invert,
    } = this.props;

    const childArray = React.Children.toArray(children);
    const childSet = new Set(childArray);
    const header = childArray.find(child => child.type === GroupContainerHeader);
    childSet.delete(header);

    return (
      <div className={classNames(classes.container, className, { invert })}>
        {header}
        <div className={classes.friendsContainer}>
          {[...childSet]}
        </div>
      </div>
    );
  }
}

function applyStyles(theme: Theme) {
  return {
    container: {
      color: theme.color.basis3,
      backgroundColor: theme.color.white,
      display: 'flex',
      flexDirection: 'column',
      overflow: 'hidden',
      '&.invert': {
        color: theme.color.basis6,
        backgroundColor: theme.color.basis2,
        '& $friendsContainer': {
          backgroundColor: theme.color.basis2,
        },
      },
    },
    friendsContainer: {
      flex: [1, 1, 'auto'],
      overflowY: 'auto',
      overflowX: 'hidden',
      backgroundColor: colorUtils(theme.color.white).darken(0.048).hex(),
      display: 'flex',
      flexDirection: 'column',
    },
  };
}

export default useSheet(applyStyles)(GroupContainer);
